import { ChevronDownIcon, ChevronRightIcon, XIcon, CheckIcon } from '@heroicons/react/outline'
import React, { FC, useState, useEffect } from 'react'
import { StyledDraftDrawerHeader } from '.'
import useDraft from '../../../redux/draft-drawer/useDraft'
import { RecentDraftsModal } from '../../Modals'
import { Button, LineInput } from '../../System'
import { useDraftActions } from '../../DraftsView'
import useDraftsList from '../../../redux/drafts-list/useDraftsList'

type Props = {
  closeDrawer: () => void;
}

const DraftDrawerHeader: FC<Props> = ({ closeDrawer }) => {
  const {
    _id,
    title,
    isUsed: draftUsed,
    isNew: draftNew,
    actions: { closeDraft, setDraftTitle }
  } = useDraft()
  const { actions: { draftUsed: markDraftUsed } } = useDraftsList()
  const { toggleDraftUsed } = useDraftActions()
  const [isUsed, setIsUsed] = useState(false)
  const [loadingUsed, setLoadingUsed] = useState(false)
  const [showRecentDraftsModal, setShowRecentDraftsModal] = useState(false)

  const handleUse = async () => {
    if (!_id) {
      return
    }

    setLoadingUsed(true)
    setIsUsed(!isUsed)
    markDraftUsed(_id)
    await toggleDraftUsed(_id)
    setLoadingUsed(false)
  }

  useEffect(() => {
    setIsUsed(!!draftUsed)
  }, [draftUsed])

  return (
    <>
      <StyledDraftDrawerHeader isUsed={isUsed}>
        <div className="draft-header-top">
          <Button theme="ghost" isIcon onClick={() => closeDrawer()}>
            <XIcon />
          </Button>
          <Button
            type="small"
            theme="ghost"
            className="recent-drafts-btn"
            onClick={() => setShowRecentDraftsModal(!showRecentDraftsModal)}
          >
            Recent Drafts
            <ChevronDownIcon />
          </Button>
          <Button
            id="draft-drawer-close-btn"
            theme="ghost"
            className="close-btn"
            isIcon
            onClick={() => closeDraft()}
          >
            Close
            <ChevronRightIcon />
          </Button>
        </div>
        <div className="draft-header-input-area">
          <LineInput
            value={title}
            id="draft-drawer-header-title-input"
            placeholder="Untitled Draft"
            onChange={(e) => setDraftTitle(e.target.value)}
            onFocus={(e) => e.target.value === 'Untitled Draft' && e.target.select()}
          />
          {!draftNew && (
            <button className="use-btn" disabled={loadingUsed} onClick={() => handleUse()}>
              <CheckIcon />
            </button>
          )}
        </div>
      </StyledDraftDrawerHeader>
      <RecentDraftsModal
        isOpen={showRecentDraftsModal}
        onClose={() => setShowRecentDraftsModal(false)}
      />
    </>
  )
}

export default DraftDrawerHeader
